(() => {
  'use strict';

  const BOOK_BUTTON_SELECTOR = '[data-book-button]';
  const PRODUCT_PATH_PREFIX = '/products/';

  const text = (root, selector) =>
    (root?.querySelector(selector)?.textContent || '').replace(/\s+/g, ' ').trim();

  const value = (root, selector) =>
    (root?.querySelector(selector)?.value || '').trim();

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target?.closest?.(BOOK_BUTTON_SELECTOR);
      if (!button) return;

      if (window.Shopify?.designMode) return;
      if (button.getAttribute('aria-disabled') === 'true') return;
      if (!button.href) return;

      const card = button.closest('[data-panthera-card]');
      if (!card) return;

      const target = new URL(button.href, window.location.origin);
      if (!target.pathname.startsWith(PRODUCT_PATH_PREFIX)) return;

      const location =
        card.querySelector('[data-location-option]:checked')?.value || 'studio';

      target.searchParams.set(
        'panthera_location',
        location === 'mobile' ? 'mobile' : 'studio'
      );
      target.searchParams.set('panthera_policy_confirmed', '1');

      if (location === 'mobile') {
        target.searchParams.set(
          'panthera_mobile_address',
          value(card, '[data-mobile-address]')
        );
        target.searchParams.set(
          'panthera_mobile_city',
          value(card, '[data-mobile-city]')
        );
        target.searchParams.set(
          'panthera_mobile_phone',
          value(card, '[data-mobile-phone]')
        );
        target.searchParams.set('panthera_mobile_state', 'NJ');
        target.searchParams.set(
          'panthera_mobile_zip',
          value(card, '[data-mobile-zip]')
        );
        target.searchParams.set(
          'panthera_mobile_zone',
          text(card, '[data-mobile-zone-badge]') || 'Mobile Service'
        );
        target.searchParams.set(
          'panthera_mobile_fee',
          text(card, '[data-mobile-zone-fee]')
        );
        target.searchParams.set(
          'panthera_mobile_requirements_confirmed',
          '1'
        );
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(
        target.pathname + target.search + target.hash
      );
    },
    true
  );


  const MEMBERSHIP_PLAN_IDS = Object.freeze({
    silver: '3045228615',
    gold: '3045261383',
    black: '2888466503'
  });
  const SILVER_MOBILE_PLAN_ID = '3049816135';

  function repairMembershipSellingPlans() {
    document.querySelectorAll('[data-pmc-card]').forEach((card) => {
      const tier = (card.dataset.tier || '').toLowerCase();
      const standardPlanId = MEMBERSHIP_PLAN_IDS[tier];
      if (!standardPlanId) return;

      card.querySelectorAll('[data-pmc-vehicle]').forEach((radio) => {
        if (!radio.dataset.sellingPlan) radio.dataset.sellingPlan = standardPlanId;
        if (!radio.dataset.studioSellingPlan) radio.dataset.studioSellingPlan = standardPlanId;

        if (tier === 'silver' && !radio.dataset.mobileSellingPlan) {
          radio.dataset.mobileSellingPlan = SILVER_MOBILE_PLAN_ID;
        }
      });

      const checked = card.querySelector('[data-pmc-vehicle]:checked');
      if (checked) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairMembershipSellingPlans, { once: true });
  } else {
    repairMembershipSellingPlans();
  }

  document.addEventListener('shopify:section:load', repairMembershipSellingPlans);

})();